/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'

/**
 * Declare Variable
 */
const defaultActiveTables = []
const defaultActiveTablesOrders = []
const defaultSelectedTable = null

/**
 * Export
 */
export const activeTables = handleActions({
  GET_ACTIVE_TABLES: (state, action) => {
    return action.payload
  },
}, defaultActiveTables)

export const activeTablesOrders = handleActions({
  GET_ACTIVE_TABLES_ORDERS: (state, action) => {
    return action.payload
  },
}, defaultActiveTablesOrders)

export const selectedTable = handleActions({
  UPDATE_SELECTED_TABLE: (state, action) => {
    return action.payload
  },
}, defaultSelectedTable)

export default {
  activeTables,
  activeTablesOrders,
  selectedTable,
}



// WEBPACK FOOTER //
// ./src/reducers/components/table.js